<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="8"
      >
        <v-tabs
          v-model="activeTab"
          active-class="active-tab"
          background-color="transparent"
          height="30"
          hide-slider
          show-arrows
        >
          <v-tab :href="`#${$t('NII.Tab.SynthesisRisk.Slug')}`">
            {{ $t('NII.Tab.SynthesisRisk.Title') }}
          </v-tab>
          <v-tab :href="`#${$t('NII.Tab.InternalThresholds.Slug')}`">
            {{ $t('NII.Tab.InternalThresholds.Title') }}
          </v-tab>
        </v-tabs>
      </v-col>
      <v-col
        cols="12"
        md="4"
        class="d-flex justify-end align-center"
      >
        <banking-switch
          v-if="riskSelectionVisible"
          v-model="isRisk3mSelected"
          :enabled-label="$t('NII.PeriodSwitch.Risk3m')"
          :disabled-label="$t('NII.PeriodSwitch.Risk1y')"
          @input="onPeriodChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-tabs-items
          v-model="activeTab"
          class="fill-height"
        >
          <v-tab-item :value="$t('NII.Tab.SynthesisRisk.Slug')">
            <synthesis-risk />
          </v-tab-item>
          <v-tab-item :value=" $t('NII.Tab.InternalThresholds.Slug')">
            <internal-thresholds />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import routerTabState        from '@/mixins/routerTabState'
import SynthesisRisk from '@/theme/default/views/banking/risk/interest-rate/NII/SynthesisRisk'
import InternalThresholds from '@/theme/default/views/banking/risk/interest-rate/NII/InternalThresholds'
import BankingSwitch from '@/theme/default/components/common/BankingSwitch'

export default {
  name      : 'NiiBase',
  components: {
    SynthesisRisk,
    InternalThresholds,
    BankingSwitch
  },
  directives: {},
  mixins    : [routerTabState],
  dataStore : {
    niiAnalysisData     : 'NII.FindNIIAnalysis',
    selectedPeriod      : 'NII.SelectedPeriod',
    riskSelectionVisible: 'NII.FindSummaryData.Data.RiskSelectionVisible'
  },
  enums    : {},
  dataModel: null,
  data () {
    return {
      isRisk3mSelected: false
    }
  },
  computed: {
  },
  watch: {
    selectedPeriod (newPeriod) {
      this.isRisk3mSelected = newPeriod === 'risk3mAnalysisData'
    }
  },
  created () {
    this.isRisk3mSelected = this.selectedPeriod === 'risk3mAnalysisData'
  },
  methods: {
    onPeriodChange (isRisk3m) {
      const newPeriod = isRisk3m ? 'risk3mAnalysisData' : 'risk12mAnalysisData'
      this.$set(this, 'selectedPeriod', newPeriod)

      // Emit event to refresh data in child components
      this.$bus.$emit('nii:period-changed', newPeriod)
    }
  }
}
</script>

<style scoped>

</style>
